import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { P, fs, fontSans } from '../theme/tokens';

const Row = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
`;

const Area = styled.textarea`
  flex: 1;
  min-height: 46px;
  max-height: 140px;
  resize: vertical;
  padding: 12px 14px;
  border: 1px solid ${P.border};
  border-radius: 10px;
  font-family: ${fontSans};
  font-size: ${fs.sm}px;
  line-height: 1.5;
  color: ${P.ink};
  outline: none;
  transition: border-color 120ms, box-shadow 120ms;

  &:focus {
    border-color: ${P.navy};
    box-shadow: 0 0 0 3px rgba(30, 58, 95, 0.12);
  }
  &:disabled {
    background: ${P.gray100};
    cursor: not-allowed;
  }
`;

const Send = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 46px;
  padding: 0 18px;
  border: none;
  border-radius: 10px;
  background: ${P.grad};
  color: ${P.white};
  font-family: inherit;
  font-size: ${fs.sm}px;
  font-weight: 600;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${P.gradHover};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  svg {
    font-size: 11px;
  }
`;

const Foot = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 9px;
`;

const Count = styled.span`
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  color: ${(p) => (p.$over ? P.danger : P.subtle)};
`;

const SMS_SEGMENT = 160;

export default function Composer({ value, onChange, onSend, sending, disabled, extra, maxLength = 1600 }) {
  const canSend = !disabled && !sending && value.trim().length > 0 && value.length <= maxLength;
  const segments = Math.max(1, Math.ceil(value.length / SMS_SEGMENT));

  const onKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (canSend) onSend();
    }
  };

  return (
    <div>
      <Row>
        <Area
          value={value}
          disabled={disabled}
          aria-label="Message"
          placeholder={disabled ? 'You do not have permission to send' : 'Type your message…'}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={onKeyDown}
        />
        <Send type="button" onClick={onSend} disabled={!canSend}>
          <FontAwesomeIcon icon={faPaperPlane} />
          {sending ? 'Sending…' : 'Send'}
        </Send>
      </Row>
      <Foot>
        {extra || <span />}
        <Count $over={value.length > maxLength}>
          {value.length}/{maxLength} · {segments} SMS
        </Count>
      </Foot>
    </div>
  );
}
